<template>
  <div id="basketball_playerIndex" ref="basketballPlayerIndexDom">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        @changeSelectEvent="changeSelect"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div class="group_box">
      <div class="table_container" ref="tableParentDom">
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :isClickFlag="isClickFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="0"
          :jumpRouterPathNames="jumpRouterPathNames"
          :unClickDetailMode="unClickDetailMode"
          v-show="tableData && tableData.length > 0"
        ></nodeTree_table>
      </div>

      <span
        v-show="isShowLoadBtn"
        class="moreBtn"
        :class="loading ? 'moreLoading' : ''"
        @click="clickMoreBtn(loading)"
      >
        <i class="moreBtnText" v-text="'更多加载'"></i>
      </span>
      <span class="noMoreClass" v-show="noMore">没有更多了</span>
      <span class="noDataClass" v-show="noData">暂无数据</span>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>
<script>
import {
  https_basketball_seasonList,
  https_season_teamList,
  https_positionNameList,
  https_playerList,
} from '@api/platfrom_basketball_api'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import BackTop from '@components/base/backTop.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

export default {
  name: 'basketball_playerIndex',
  components: { marathon_select_opt, nodeTree_table, BackTop },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      loading: false,
      tableModeArr: ['playerData leagueCBA', 'playerData basketballCup'],
      tableMode: 'playerData leagueCBA',
      jumpRouterPathNames: null,
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: true,
      isClickFlag: false,
      variableColWidthVw: 13.8,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      totalTotal: 0,
      curInputVal: '',
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入球员名称',
        iconType: 'search',
      }, //控制marathon_select_opt中的输入框是否显示
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      seasonArr: [],
      teamArr: [],
      posArr: [],
      currStageSeason: '',
      currStageTeam: '',
      currStagePos: '',
      selectOptData: {
        configArr: [
          {
            type: 'season',
            title: '赛季',
            origin_keyVal: ['seasonId', 'seasonName'],
            dataName: 'seasonArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'team',
            title: '球队',
            origin_keyVal: ['value', 'name'],
            dataName: 'teamArr',
            selectIndex: 0,
            isFilterable: true,
          },
          {
            type: 'pos',
            title: '球员位置',
            origin_keyVal: ['value', 'name'],
            dataName: 'posArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      pnum: 1,
      psize: 10,
      beforeScrollTop: 0,
      showBackTop: false,
      scrollAreaDomById: 'containerFull_body',
    }
  },
  created() {
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
        pathName_playerDetail: `playerDetailIndex_${moduleRouteNameEn}`,
      }

      if (this.currThemeObj.sportType === 'basketball') {
        if (['CBA'].includes(moduleRouteNameEn)) {
          this.tableMode = this.tableModeArr[0]
        } else if (['FIBAWA', 'FIBAMA'].includes(moduleRouteNameEn)) {
          this.currStageSeason = this.currSid
          this.tableMode = this.tableModeArr[1]
          const configArr = []
          this.selectOptData.configArr.forEach((item, index) => {
            if (index !== 0) {
              configArr.push(item)
            }
          })
          this.selectOptData.configArr = configArr
        }
      }
    }
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug(
      'this.parentWidthPx:',
      this.parentWidthPx,
      this.$refs.tableParentDom.scrollHeight
    )
  },
  computed: {
    isShowLoadBtn() {
      return (
        this.tableData &&
        this.tableData.length < this.totalTotal &&
        this.totalTotal !== 0
      )
    },
    noMore() {
      return (
        this.tableData &&
        this.tableData.length >= this.totalTotal &&
        this.totalTotal !== 0
      )
    },
    noData() {
      return (
        this.tableData &&
        this.tableData.length === 0 &&
        !this.loading &&
        this.totalTotal === 0
      )
    },
    unClickDetailMode() {
      console.debug('this.currThemeObj:', this.currThemeObj)
      let flag = false
      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        flag = true //不可点击进入详情
      }
      return flag
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (!this.currStageSeason) {
        await this.getSeasonList()
      }
      await this.getStageTeamList()
      await this.getStagePositionNameList()
      this.computedSelectOpt(this.selectOptData.configArr)
      await this.getPlayerData()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt 11:',
            config.type,
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'season') {
            this.currStageSeason = valPathArr[1]
            // this.computedSelectOpt(this.selectOptData.configArr)
            this.getStageTeamList()
          } else if (valPathArr[0] === 'team') {
            this.currStageTeam = valPathArr[1]
          } else if (valPathArr[0] === 'pos') {
            this.currStagePos = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.resetTableParams()
          this.getPlayerData()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.resetTableParams()
      this.getPlayerData()
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }

      this.beforeScrollTop = 0
      // this.threshold = 5
      // this.DIRECTION_ENUM = {
      //   DOWN: 'down',
      //   UP: 'up',
      // }

      this.scrollAreaDom = document.getElementById(`${this.scrollAreaDomById}`)

      console.debug('this.scrollAreaDom:', this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    scrollListenerEvent() {
      console.debug('scrollListenerEvent')
      const scrollTop = this.scrollAreaDom.scrollTop

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop(num) {
      let scrollTop = num ? num : 0
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, scrollTop)
      }
    },
    clickMoreBtn(flag) {
      if (!flag) {
        this.loading = !flag
        this.pnum++
        this.getPlayerData()
      }
    },
    resetTableParams() {
      this.loading = true
      this.pnum = 1
      this.totalTotal = 0
      this.tableData = []
    },
    async getSeasonList() {
      await https_basketball_seasonList(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
      })
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.seasonArr = res.data
            this.currStageSeason = this.seasonArr[0].seasonId
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getStageTeamList() {
      await https_season_teamList(this.axiosBaseUrl, this.$axios, {
        sid: this.currStageSeason,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const teamArr = res.data
              ? res.data.map((item) => {
                  return {
                    value: item.teamId,
                    name: item.teamName,
                  }
                })
              : []
            this.teamArr = [].concat(
              JSON.parse(JSON.stringify(this.selectAllObj)),
              teamArr
            )
            if (this.teamArr.length > 0) {
              this.currStageTeam = this.teamArr[0].value
            }
            console.debug('getStageTeamList:', this.teamArr)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getStagePositionNameList() {
      await https_positionNameList(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const posArr = res.data
              ? res.data.map((item) => {
                  return {
                    value: item.positionCode,
                    name: item.positionName,
                  }
                })
              : []
            this.posArr = [].concat(
              JSON.parse(JSON.stringify(this.selectAllObj)),
              posArr
            )
            if (this.posArr.length > 0) {
              this.currStagePos = this.posArr[0].value
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerData() {
      await https_playerList(this.axiosBaseUrl, this.$axios, {
        sid: this.currStageSeason,
        tid: this.currStageTeam === 'all' ? '' : this.currStageTeam,
        pcode: this.currStagePos === 'all' ? '' : this.currStagePos,
        pname: this.curInputVal,
        pnum: this.pnum,
        psize: this.psize,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data && res.data.middle) {
              const leftColumns = res.data.left.slice(4)
              const middleColumns = res.data.middle
              const rightColumns = res.data.right
              // const fristColumns_left = leftColumns.slice(0, 3)
              // const otherColumns_left = leftColumns.slice(3)
              this.defaultWidthVwNum = res.data.middle.length + 1
              if (this.tableColumnData.length == 0) {
                let tableColumnData = []
                let leftColumnObjArr = []
                let rightColumnObjArr = []
                for (let i = 0; i < leftColumns.length; i++) {
                  leftColumnObjArr.push({
                    prop: 'shirtNumber-playerLogo-playerName', //fristColumnPropArr.join('-'),
                    label: '球员',
                    widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                    className: 'shirtNumber-playerLogo-playerName', //单独定制的头部样式class
                    fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  })
                  leftColumnObjArr.push({
                    prop: 'teamName', //fristColumnPropArr.join('-'),
                    label: '球队',
                    widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
                    className: 'teamName', //单独定制的头部样式class
                    fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  })
                }

                tableColumnData = [].concat(leftColumnObjArr)
                for (let i = 0; i < middleColumns.length; i++) {
                  const item = middleColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
                    className: '', //单独定制的头部样式class
                    selected: item.selected,
                  })
                }

                for (let i = 0; i < rightColumns.length; i++) {
                  rightColumnObjArr.push({
                    prop: 'leftTeamName', //fristColumnPropArr.join('-'),
                    label: '球队',
                    widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                    className: 'columnTeamNameClass', //单独定制的头部样式class
                    fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
                  })
                }

                this.tableColumnData = [].concat(
                  tableColumnData,
                  rightColumnObjArr
                )
              }
              this.totalTotal = res.data.total
              const newTableData = res.data.datas
                ? res.data.datas.map((rowItem) => {
                    rowItem.shirtNumber = rowItem.jerseyNumber
                      ? rowItem.jerseyNumber
                      : ''
                    rowItem.playerLogo = rowItem.profilePicture
                      ? rowItem.profilePicture
                      : ''
                    return rowItem
                  })
                : []
              if (this.tableData) {
                this.tableData = [].concat(this.tableData, newTableData)
              } else {
                this.tableData = [].concat(newTableData)
              }
              console.debug('this.tableData:', this.tableData)
              this.loading = false

              this.initScroll()
              this.$nextTick(() => {
                this.goBackTop(this.beforeScrollTop)
              })
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#basketball_playerIndex {
  width: 100%;
  .select_area {
    padding: 2.083vw 0;
  }
  .group_box {
    position: relative;
    width: 100%;
    padding-bottom: 2.778vw;
    .table_container {
      width: 100%;
    }
  }
  .noMoreClass,
  .noDataClass {
    display: block;
    width: 100%;
    line-height: 5.55vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
  .moreBtn {
    display: block;
    position: relative;
    margin: 2.083vw auto;
    width: 5.55vw;
    height: 5.55vw;
    text-align: center;
    line-height: 5.55vw;
    font-size: 0.833vw;
    border-radius: 50%;
    border: 1px dashed var(--mixtmt_greyColor6);
    color: var(--mixtmt_greyColor3);
    .moreBtnText {
      display: block;
      position: absolute;
      top: 0;
      z-index: 100;
      left: 0;
      width: 100%;
    }

    &.moreLoading::before {
      content: '\20';
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 2;
      width: 0.555vw;
      height: 0.555vw;
      margin: -2.22vw 0 0 -2.22vw;
      border-radius: 0.278vw;
      transform: translate(-50%, -50%);
      background-color: var(--mixtmt_mainColor);
      transform-origin: 2.22vw 2.22vw;
      animation: moreLoadingAn 2s linear infinte;
      -webkit-animation: moreLoadingAn 2s linear infinite;
      -moz-animation: moreLoadingAn 2s linear infinite;
      -o-animation: moreLoadingAn 2s linear infinite;
    }
  }

  @keyframes moreLoadingAn {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes moreLoadingAn {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @-moz-keyframes moreLoadingAn {
    0% {
      -moz-transform: rotate(0deg);
    }
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-o-keyframes moreLoadingAn {
    0% {
      -o-transform: rotate(0deg);
    }
    100% {
      -o-transform: rotate(360deg);
    }
  }
}

.mixtmt_pc #basketball_playerIndex {
  .moreBtn:hover {
    /* border: 1px dashed var(--mixtmt_mainColor);
    background-color: var(--mixtmt_mainColor);
    color: var(--mixtmt_whiteColor); */
    cursor: pointer;
    &.moreLoading {
      cursor: default;
    }
  }
}
</style>
